import { Component, OnInit } from '@angular/core';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { NavController } from '@ionic/angular';
import { GlobalVariable } from '../global';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.page.html',
  styleUrls: ['./thank-you.page.scss'],
})
export class ThankYouPage {
  email;
  constructor(
    private nativeStorage: NativeStorage,
    public globals: GlobalVariable,
    public navCtrl: NavController
  ) {
    this.globals.Email = localStorage.getItem('userEmail');
    console.log(this.email);
  }

  done() {
    // if (this.globals.caos_flag) {
    //   this.globals.udid = undefined;
    //   this.logout();
    // } else {
    if (this.globals.review_enabled == 'true') {
      this.navCtrl.pop().then((res) => {
        console.log(res);
        this.navCtrl.navigateForward('reviews', {
          state: { thankYouPage: true },
        });
      });
    } else {
      this.navCtrl.pop();

      this.navCtrl.navigateRoot('home');
    }
    // }
  }

  logout() {
    this.globals.Product.length = 0;
    this.globals.cartflag = false;
    this.navCtrl.navigateRoot('home');
  }
}
